import URLConfig from '@Config/urls/url.config';
import AtmMenuLink from '@Layouts/sidebar/sidebarLinkData/administration/integrationSettings/AtmMenuLink';
import BaseMenuLink from '@Layouts/sidebar/sidebarLinkData/administration/integrationSettings/BaseMenuLink';
import { FaUsers, FaChartBar, FaChartPie, 
  FaCreditCard, FaRandom,
  FaMoneyCheck, FaShieldAlt, FaDiaspora, FaExchangeAlt } from "react-icons/fa";
import { LinkItemProps } from './AppSidebar';
import ArchivedTablesMenuLink from './sidebarLinkData/administration/archiving/ArchivedTablesMenuLink';
import BatchessMenuLink from './sidebarLinkData/administration/archiving/BatchesMenuLink';
import { BaseSettingsBankMenu } from './sidebarLinkData/administration/baseSettings/BaseSettingsBank';
import { UsersModuleMenu } from './sidebarLinkData/administration/users/users';
import { TransactionMenuLink } from './sidebarLinkData/transaction/TransactionMenuLink';
import { MerchantMenuLink } from './sidebarLinkData/terminalManagementSystem/merchant/MerchantMenuLink';
import { InterfaceMenuLink } from './sidebarLinkData/interfaceManagement/InterfaceMenuLink';
import { GlobalParametersMenu, CardMenu, PrepaidOperationsMenu, CompanyMenu, CardHolderMenu } from "./sidebarLinkData/cardManagementSystem/prepaid/Prepaid";
import { SmartGlobalParametersMenu, ScriptProcessingMenu } from "./sidebarLinkData/cardManagementSystem/smart/Smart";
import ParametersMenuLink from './sidebarLinkData/cardManagementSystem/cardHolder/ParametersMenuLinks';
import CardFeesMenuLink from './sidebarLinkData/cardManagementSystem/cardHolder/CardFeesMenuLinks';
import CardDataMenuLink from './sidebarLinkData/cardManagementSystem/cardHolder/CardDataMenuLinks';
import CardPersonalizationMenuLink from "./sidebarLinkData/cardManagementSystem/cardHolder/CardPersonalizationMenuLinks";
import CardOperationMenuLink from './sidebarLinkData/cardManagementSystem/cardHolder/CardOperationMenuLink';
import GlobalSettingsMenuLink from './sidebarLinkData/cardManagementSystem/debit/GlobalSettingsMenuLinks';
import HolderManagementMenuLink from './sidebarLinkData/cardManagementSystem/debit/HolderManagementMenuLinks';
import DebitOperationsMenuLink from './sidebarLinkData/cardManagementSystem/debit/DebitOperationsMenuLinks';
import BankMenuLink from './sidebarLinkData/terminalManagementSystem/gabManagement/BankMenuLinks';
import TerminalMenuLink from './sidebarLinkData/terminalManagementSystem/gabManagement/TerminalMenuLinks';
import GlobalSettingsMenu from './sidebarLinkData/terminalManagementSystem/gabManagement/GlobalSettingsMenuLinks';
import FMGlobalSettingsMenu from './sidebarLinkData/fraudManagement/GlobalSettingsMenuLinks';
import BatchesManagementMenuLink from './sidebarLinkData/batchesProcessing/BatchesManagementMenuLinks';
import EmitterMenuLink from './sidebarLinkData/fraudManagement/EmitterMenuLinks';
import ScriptBatchesMenuLink from './sidebarLinkData/cardManagementSystem/smart/BatchesMenuLinks';

const MenuLinkData: Array<LinkItemProps> = [
  {
    name: 'Dashboard',
    icon: FaChartPie,
    link: URLConfig.HOME.DASHBOARD,
    level: 0,
  },
  {
    name: 'Administration',
    icon: FaUsers,
    link: URLConfig.ADMIN.ROOT,
    level: 0,
    subMenu: [
      {
        name: 'Archivage',
        link: URLConfig.ADMIN.ARCHIVING.ROOT,
        level: 1,
        subMenu: [
          {
            name: 'Paramètres',
            link: URLConfig.ADMIN.ARCHIVING.SETTINGS,
            level: 2,
          },
          {
            name: 'Batches',
            level: 2,
            subMenu: [...BatchessMenuLink],
          },
          {
            name: 'Tables archivées',
            level: 2,
            subMenu: [
              ...ArchivedTablesMenuLink
            ]
          },
          
        ],
      },
      {
        name: 'Basic settings',
        level: 1,
        // link: URLConfig.ADMIN.BASE_SETTINGS.ROOT,
        subMenu: [
          {
            name: 'Centre',
            level: 2,
            subMenu: [
              {
                name: 'Mise à jour',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.UPDATE,
                level: 3,
              },
              {
                name: 'Systeme de paiement',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PAYMENT_SYSTEM,
                level: 3,
              },
              {
                name: 'Devise',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.DEVISE,
                level: 3,
              },
              {
                name: 'Commercant',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.MERCHANT,
                level: 3,
              },
              {
                name: 'Banque',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.BANK,
                level: 3,
              },
              {
                name: 'Commission centre',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU
                  .CENTER_COMMISSION,
                  level: 3,
              },
              {
                name: 'TVA',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.TVA,
                level: 3,
              },
              {
                name: 'Paramétres',
                link: URLConfig.ADMIN.BASE_SETTINGS.CENTER_MENU.PARAMETERS.ROOT,
                level: 3,
              },
            ],
          },
          {
            ...BaseSettingsBankMenu,
          },
          {
            name: 'Agence',
            link: URLConfig.ADMIN.BASE_SETTINGS.AGENCE,
            level: 2,
          },
        ],
      },
      {
        ...UsersModuleMenu,
      },
      {
        name: 'Integration Parameters',
        link: URLConfig.ADMIN.INTEGRATION_SETTINGS.ROOT,
        level: 1,
        subMenu: [
          {
            name: 'Base',
            subMenu: [...BaseMenuLink],
            level: 2,
          },
          {
            name: 'ATM',
            subMenu: [...AtmMenuLink],
            level: 2,
          },
          {
            name: 'Cardholder',
            link: URLConfig.ADMIN.INTEGRATION_SETTINGS.CARDHOLDER,
            level: 2,
          },
          {
            name: 'Merchant',
            link: URLConfig.ADMIN.INTEGRATION_SETTINGS.MERCHANT,
            level: 2,
          },
          {
            name: 'Switch and Visa Basell',
            link: URLConfig.ADMIN.INTEGRATION_SETTINGS.SWITCH_AND_VISA_BASELL,
            level: 2,
          },
          {
            name: 'Batch Processing',
            link: URLConfig.ADMIN.INTEGRATION_SETTINGS.BATCH_PROCESSING,
            level: 2,
          },
        ],
      },
    ],
  },
  {
    name: "Card Management System",
    link: URLConfig.CARD_MANAGEMENT_SYSTEM.ROOT,
    icon: FaCreditCard,
    level: 0,
    subMenu: [
      {
        name: 'Titulaire de carte',
        link: URLConfig.ADMIN.ARCHIVING.ROOT,
        level: 1,
        subMenu: [
          {
            name: 'Paramètres',
            subMenu: [...ParametersMenuLink],
            level: 2,
          },
          {
            name: 'Frais Carte',
            subMenu: [...CardFeesMenuLink],
            level: 2,
          },          
          {
            name: 'Données Carte',
            subMenu: [...CardDataMenuLink],
            level: 2,
          },
          {
            name: 'Personalisation Carte',
            subMenu: [...CardPersonalizationMenuLink],
            level: 2,
          },
          
          {
            name: 'Opérations carte',
            subMenu: [...CardOperationMenuLink],
            level: 2,
          },
          
        ],
      },
      {
        name: 'Carte Prépayée',
        link: URLConfig.CARD_MANAGEMENT_SYSTEM.ROOT,
        level: 1,
        subMenu: [
          {
            name: 'Parametres globaux',
            link: URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.ROOT,
            level: 2,
            subMenu: [
              ...GlobalParametersMenu
            ]
          },
          {
            name: 'Gestion carte',
            link: URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.ROOT,
            level: 2,
            subMenu: [
              ...CardMenu
            ]
          },
          {
            name: 'Operations prépayées',
            link: URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.ROOT,
            level: 2,
            subMenu: [
              ...PrepaidOperationsMenu
            ]
          },
          {
            name: 'Entreprises',
            link: URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.ROOT,
            level: 2,
            subMenu: [
              ...CompanyMenu
            ]
          },
          {
            name: 'Gestion porteur',      
            link: URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.ROOT,
            level: 2,
            subMenu: [
              ...CardHolderMenu
            ]
          }
            
        ],
      },
      {
        name: 'Carte Débit',
        link: URLConfig.ADMIN.ARCHIVING.ROOT,
        level: 1,
        subMenu: [
          {
            name: 'Paramètres Globaux',
            subMenu: [...GlobalSettingsMenuLink],
            level: 2,
          },
          {
            name: 'Gestion Porteur',
            subMenu: [...HolderManagementMenuLink],
            level: 2,
          },
          {
            name: 'Opérations Débit',
            subMenu: [...DebitOperationsMenuLink],
            level: 2,
          },
        ],
      },
      {
        name: 'Carte à Puce',
        link: URLConfig.ADMIN.ARCHIVING.ROOT,
        level: 1,
        subMenu: [
          {
            name: 'Parametres globaux',
            link: URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.ROOT,
            level: 2,
            subMenu: [
              ...SmartGlobalParametersMenu
            ]
          },
          {
            name: 'Script procesing',
            link: URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.ROOT,
            level: 2,
            subMenu: [
              ...ScriptProcessingMenu
            ]
          },
          {
            name: 'Batches',
            level: 2,
            subMenu: [
              ...ScriptBatchesMenuLink
            ]
          },
        ],
      },

    ]
  },
  {
    name: 'Transactions',
    icon: FaExchangeAlt,
    level: 0,
    subMenu: [...TransactionMenuLink],
  },
  {
    name: 'Traitement Batches',
    icon: FaRandom,
    level: 0,
    subMenu: [...BatchesManagementMenuLink],
  },
  {
    name: 'Terminal Management System',
    icon: FaDiaspora,
    level: 0,
    subMenu: [
      {
        name: 'Commerçant',
        level: 1,
        subMenu: [
          ...MerchantMenuLink
        ]
      },
      {
        name: 'Gestion GAB',
        level: 1,
        subMenu: [
          {
            name: 'Banque',
            level: 2,
            subMenu: [
              ...BankMenuLink
            ]
          },
          {
            name: 'Paramètres globaux',
            level: 2,
            subMenu: [
              ...GlobalSettingsMenu
            ]
          },
          {
            name: 'Terminal',
            level: 2,
            subMenu: [
              ...TerminalMenuLink
            ]
          },
        ],
      },
    ]
  },
  {
    name: 'Gestion Interfaces',
    icon: FaMoneyCheck,
    level: 0,
    subMenu: [...InterfaceMenuLink],
  },
  {
    name: 'Gestion Fraude',
    icon: FaShieldAlt,
    level: 0,
    subMenu: [
      {
        name: 'Paramètres globaux',
        level: 1,
        subMenu: [
          ...FMGlobalSettingsMenu
        ]
      },
      {
        name: 'Emetteur',
        level: 1,
        subMenu: [
          ...EmitterMenuLink
        ]
      },
    ],
  },
  {
    name: 'Reporting',
    icon: FaChartBar,
    level: 0,
    subMenu: [
      {
        name: 'Transactions',
        link: URLConfig.REPORTING.TRANSACTIONS,
        level: 1,
      },
      {
        name: 'Titulaire de carte',
        link: URLConfig.REPORTING.CARDHOLDERS,
        level: 1,
      },
      {
        name: 'Carte Prépayée',
        link: URLConfig.REPORTING.PREPAID,
        level: 1,
      },
      {
        name: 'Commerçant',
        link: URLConfig.REPORTING.MERCHANT,
        level: 1,
      },
      {
        name: 'Carte Débit',
        link: URLConfig.REPORTING.DEBIT,
        level: 1,
      },
      {
        name: 'Fraude',
        link: URLConfig.REPORTING.FRAUD,
        level: 1,
      },
      {
        name: 'Visa Base 2',
        link: URLConfig.REPORTING.VISA_BASE_2,
        level: 1,
      },
      {
        name: 'GIMAC',
        link: URLConfig.REPORTING.GIMAC,
        level: 1,
      },
    ],
  },
];

export default MenuLinkData;
